import { Popconfirm } from 'antd';
import React, { useState, useMemo } from 'react';
import { apiHolder as api, getIn18Text } from 'api';
import classnames from 'classnames/bind';
import style from './TagGuide.module.scss';
import mailtagGuideImage from '@/images/icons/mail/mailtagguide.png';
import { MAIL_TAG_GUIDE_LOCAL_KEY } from '@web-mail/common/constant';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
const realStyle = classnames.bind(style);
const eventApi = api.api.getEventApi();
export const TagGuideContent = () => {
    return (React.createElement("div", { className: realStyle('mailTagGuide'), onClick: e => e.stopPropagation() },
        React.createElement("img", { src: mailtagGuideImage, alt: "", className: realStyle('guidImg') }),
        React.createElement("div", { className: realStyle('tagGuidTitle') }, getIn18Text('DABIAOQIANKESHEZKJJL！')),
        React.createElement("div", { className: realStyle('tagGuidSubTitle') }, getIn18Text('XINJIANHEXIUGAIBQSKYZDYBQKJJ。'))));
};
export const TagGuideModal = props => {
    const { visiable, onClose } = props;
    const handleVisiable = (visiable) => {
        if (!visiable) {
            onClose && onClose();
            localStorage.setItem(MAIL_TAG_GUIDE_LOCAL_KEY, 'true');
        }
    };
    const handleOk = e => {
        onClose && onClose();
        localStorage.setItem(MAIL_TAG_GUIDE_LOCAL_KEY, 'true');
        eventApi.sendSysEvent({
            eventName: 'mailMenuOper',
            eventData: {},
            eventStrData: 'mailTagGuideModalClose',
        });
    };
    return visiable ? (React.createElement(SiriusModal, { visible: visiable, onOk: handleOk, wrapClassName: realStyle('tagGuideModalWrap'), onVisiable: handleVisiable, width: 320, cancelButtonProps: { style: { display: 'none' } }, closable: false, maskClosable: true, onCancel: handleOk },
        React.createElement(TagGuideContent, null))) : (React.createElement(React.Fragment, null));
};
const TagGuide = props => {
    const localShow = useMemo(() => {
        try {
            return !localStorage.getItem(MAIL_TAG_GUIDE_LOCAL_KEY);
        }
        catch (e) {
            return false;
        }
    }, []);
    const [visible, setVisible] = useState(localShow);
    const handleOk = e => {
        e.stopPropagation();
        localStorage.setItem(MAIL_TAG_GUIDE_LOCAL_KEY, 'true');
        setVisible(false);
    };
    useMsgRenderCallback('mailMenuOper', ev => {
        if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'mailTagGuideModalClose') {
            setVisible(false);
        }
    });
    return visible ? (React.createElement(Popconfirm, { title: React.createElement(TagGuideContent, null), icon: React.createElement(React.Fragment, null), placement: "top", onOpenChange: e => e.stopPropagation(), overlayClassName: realStyle('tagGuideTitleWrap'), showCancel: false, cancelButtonProps: { style: { display: 'none' } }, onConfirm: handleOk }, props.children)) : (React.createElement(React.Fragment, null));
};
export default TagGuide;
